import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, resolveDirective as _resolveDirective, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, withDirectives as _withDirectives, createElementBlock as _createElementBlock, createVNode as _createVNode } from "vue"
import _imports_0 from '../assets/logo.svg'


const _hoisted_1 = { class: "min-h-screen flex relative lg:static surface-ground" }
const _hoisted_2 = {
  id: "app-sidebar-2",
  class: "bg-cyan-800 h-screen hidden lg:block flex-shrink-0 absolute lg:static left-0 top-0 z-1 select-none",
  style: {"width":"280px"}
}
const _hoisted_3 = { class: "flex flex-column h-full" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", {
  class: "flex align-items-center px-5 bg-white flex-shrink-0",
  style: {"height":"60px"}
}, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_0,
    alt: "Image",
    height: "60"
  })
], -1)
const _hoisted_5 = { class: "overflow-y-auto mt-3" }
const _hoisted_6 = { class: "list-none p-3 m-0" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("i", { class: "pi pi-home mr-2" }, null, -1)
const _hoisted_8 = /*#__PURE__*/_createElementVNode("span", { class: "font-medium" }, "Dashboard", -1)
const _hoisted_9 = /*#__PURE__*/_createElementVNode("i", { class: "pi pi-phone mr-2" }, null, -1)
const _hoisted_10 = /*#__PURE__*/_createElementVNode("span", { class: "font-medium" }, "Phone Numbers", -1)
const _hoisted_11 = /*#__PURE__*/_createElementVNode("i", { class: "pi pi-megaphone mr-2" }, null, -1)
const _hoisted_12 = /*#__PURE__*/_createElementVNode("span", { class: "font-medium" }, "Campaigns", -1)
const _hoisted_13 = /*#__PURE__*/_createElementVNode("i", { class: "pi pi-user mr-2" }, null, -1)
const _hoisted_14 = /*#__PURE__*/_createElementVNode("span", { class: "font-medium" }, "Profile", -1)
const _hoisted_15 = /*#__PURE__*/_createElementVNode("i", { class: "pi pi-cog mr-2" }, null, -1)
const _hoisted_16 = /*#__PURE__*/_createElementVNode("span", { class: "font-medium" }, "Settings", -1)
const _hoisted_17 = /*#__PURE__*/_createElementVNode("i", { class: "pi pi-file mr-2" }, null, -1)
const _hoisted_18 = /*#__PURE__*/_createElementVNode("span", { class: "font-medium" }, "Terms & Conditions", -1)
const _hoisted_19 = { class: "min-h-screen flex flex-column relative flex-auto" }
const _hoisted_20 = {
  class: "flex justify-content-between align-items-center px-5 surface-section shadow-2 relative lg:static border-bottom-1 surface-border bg-white",
  style: {"height":"60px"}
}
const _hoisted_21 = { class: "flex" }
const _hoisted_22 = { class: "cursor-pointer block lg:hidden text-700 mr-3 mt-1 p-ripple" }
const _hoisted_23 = /*#__PURE__*/_createElementVNode("i", { class: "pi pi-bars text-4xl" }, null, -1)
const _hoisted_24 = [
  _hoisted_23
]
const _hoisted_25 = { class: "cursor-pointer block lg:hidden text-700 p-ripple" }
const _hoisted_26 = /*#__PURE__*/_createElementVNode("i", { class: "pi pi-ellipsis-v text-2xl" }, null, -1)
const _hoisted_27 = [
  _hoisted_26
]
const _hoisted_28 = { class: "list-none p-0 m-0 hidden lg:flex lg:align-items-center select-none lg:flex-row surface-section border-1 lg:border-none surface-border right-0 top-100 z-1 shadow-2 lg:shadow-none absolute lg:static" }
const _hoisted_29 = /*#__PURE__*/_createElementVNode("i", { class: "pi pi-user text-base lg:text-2xl mr-2 lg:mr-0" }, null, -1)
const _hoisted_30 = /*#__PURE__*/_createElementVNode("span", { class: "block lg:hidden font-medium" }, "Profile", -1)
const _hoisted_31 = /*#__PURE__*/_createElementVNode("i", { class: "pi pi-sign-out text-base lg:text-2xl mr-2 lg:mr-0" }, null, -1)
const _hoisted_32 = /*#__PURE__*/_createElementVNode("span", { class: "block lg:hidden font-medium" }, "Sign Out", -1)
const _hoisted_33 = [
  _hoisted_31,
  _hoisted_32
]
const _hoisted_34 = { class: "p-5 flex flex-column flex-auto" }
const _hoisted_35 = { class: "flex-auto" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_router_view = _resolveComponent("router-view")!
  const _directive_ripple = _resolveDirective("ripple")!
  const _directive_styleclass = _resolveDirective("styleclass")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _hoisted_4,
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("ul", _hoisted_6, [
            _createElementVNode("li", null, [
              _withDirectives((_openBlock(), _createBlock(_component_router_link, {
                to: "/",
                class: "flex align-items-center cursor-pointer p-3 hover:bg-cyan-900 border-round text-bluegray-100 hover:text-bluegray-50 transition-duration-150 transition-colors p-ripple"
              }, {
                default: _withCtx(() => [
                  _hoisted_7,
                  _hoisted_8
                ]),
                _: 1
              })), [
                [_directive_ripple]
              ])
            ]),
            _createElementVNode("li", null, [
              _withDirectives((_openBlock(), _createBlock(_component_router_link, {
                to: { name: _ctx.routeNames.phoneNumberDetails },
                class: "flex align-items-center cursor-pointer p-3 hover:bg-cyan-900 border-round text-bluegray-100 hover:text-bluegray-50 transition-duration-150 transition-colors p-ripple"
              }, {
                default: _withCtx(() => [
                  _hoisted_9,
                  _hoisted_10
                ]),
                _: 1
              }, 8, ["to"])), [
                [_directive_ripple]
              ])
            ]),
            _createElementVNode("li", null, [
              _withDirectives((_openBlock(), _createBlock(_component_router_link, {
                to: { name: _ctx.routeNames.campaigns },
                class: "flex align-items-center cursor-pointer p-3 hover:bg-cyan-900 border-round text-bluegray-100 hover:text-bluegray-50 transition-duration-150 transition-colors p-ripple"
              }, {
                default: _withCtx(() => [
                  _hoisted_11,
                  _hoisted_12
                ]),
                _: 1
              }, 8, ["to"])), [
                [_directive_ripple]
              ])
            ]),
            _createElementVNode("li", null, [
              _withDirectives((_openBlock(), _createBlock(_component_router_link, {
                to: { name: _ctx.routeNames.userProfile },
                class: "flex align-items-center cursor-pointer p-3 hover:bg-cyan-900 border-round text-bluegray-100 hover:text-bluegray-50 transition-duration-150 transition-colors p-ripple"
              }, {
                default: _withCtx(() => [
                  _hoisted_13,
                  _hoisted_14
                ]),
                _: 1
              }, 8, ["to"])), [
                [_directive_ripple]
              ])
            ]),
            _createElementVNode("li", null, [
              _withDirectives((_openBlock(), _createBlock(_component_router_link, {
                to: { name: _ctx.routeNames.settings },
                class: "flex align-items-center cursor-pointer p-3 hover:bg-cyan-900 border-round text-bluegray-100 hover:text-bluegray-50 transition-duration-150 transition-colors p-ripple"
              }, {
                default: _withCtx(() => [
                  _hoisted_15,
                  _hoisted_16
                ]),
                _: 1
              }, 8, ["to"])), [
                [_directive_ripple]
              ])
            ]),
            _createElementVNode("li", null, [
              _withDirectives((_openBlock(), _createBlock(_component_router_link, {
                to: { name: _ctx.routeNames.termsAndConditions },
                class: "flex align-items-center cursor-pointer p-3 hover:bg-cyan-900 border-round text-bluegray-100 hover:text-bluegray-50 transition-duration-150 transition-colors p-ripple"
              }, {
                default: _withCtx(() => [
                  _hoisted_17,
                  _hoisted_18
                ]),
                _: 1
              }, 8, ["to"])), [
                [_directive_ripple]
              ])
            ])
          ])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_19, [
      _createElementVNode("div", _hoisted_20, [
        _createElementVNode("div", _hoisted_21, [
          _withDirectives((_openBlock(), _createElementBlock("a", _hoisted_22, _hoisted_24)), [
            [_directive_ripple],
            [_directive_styleclass, {
							selector: '#app-sidebar-2',
							enterClass: 'hidden',
							enterActiveClass: 'fadeinleft',
							leaveToClass: 'hidden',
							leaveActiveClass: 'fadeoutleft',
							hideOnOutsideClick: true
						}]
          ])
        ]),
        _withDirectives((_openBlock(), _createElementBlock("a", _hoisted_25, _hoisted_27)), [
          [_directive_ripple],
          [_directive_styleclass, {
						selector: '@next',
						enterClass: 'hidden',
						enterActiveClass: 'fadein',
						leaveToClass: 'hidden',
						leaveActiveClass: 'fadeout',
						hideOnOutsideClick: true
					}]
        ]),
        _createElementVNode("ul", _hoisted_28, [
          _createElementVNode("li", null, [
            _withDirectives((_openBlock(), _createBlock(_component_router_link, {
              to: { name: _ctx.routeNames.userProfile },
              class: "flex p-3 lg:px-3 lg:py-2 align-items-center text-600 hover:text-900 hover:surface-100 font-medium border-round cursor-pointer transition-duration-150 transition-colors p-ripple"
            }, {
              default: _withCtx(() => [
                _hoisted_29,
                _hoisted_30
              ]),
              _: 1
            }, 8, ["to"])), [
              [_directive_ripple]
            ])
          ]),
          _createElementVNode("li", null, [
            _withDirectives((_openBlock(), _createElementBlock("a", {
              onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.logOut && _ctx.logOut(...args))),
              class: "flex p-3 lg:px-3 lg:py-2 align-items-center text-600 hover:text-900 hover:surface-100 font-medium border-round cursor-pointer transition-duration-150 transition-colors p-ripple"
            }, _hoisted_33)), [
              [_directive_ripple]
            ])
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_34, [
        _createElementVNode("div", _hoisted_35, [
          _createVNode(_component_router_view)
        ])
      ])
    ])
  ]))
}